import { EnvironmentsState } from './types';

const initialState: EnvironmentsState = {
  list: [],
  isLoading: false,
  error: null,
};

export default initialState;
